
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const LaunchpadHero = () => {
  return (
    <section className="relative pt-32 pb-24 lg:pt-40 lg:pb-32 bg-muted-taupe">
      <div className="absolute inset-0 bg-gradient-to-br from-muted-taupe to-taupe/40"></div>
      
      <div className="relative max-w-5xl mx-auto px-6 lg:px-12 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <p className="font-inter text-xs uppercase tracking-widest text-warm-gold mb-6">
            Career Acceleration Program
          </p>
          
          <h1 className="font-playfair text-5xl lg:text-7xl font-semibold text-charcoal leading-tight mb-8">
            Launch Your PM Career.<br />
            Lead with <em className="text-warm-gold">Confidence</em>.<br />
            Deliver with Precision.
          </h1>
          
          <p className="font-inter text-xl text-charcoal/70 max-w-3xl mx-auto mb-12 leading-relaxed">
            Structured mentorship for aspiring and advancing project managers ready to elevate their impact.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-5 justify-center">
            <Link
              to="/apply"
              className="inline-flex items-center justify-center bg-warm-gold text-charcoal font-inter font-semibold px-8 py-4 rounded-full hover:bg-soft-bronze transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Apply Now
            </Link>
            <Link
              to="/book-consultation"
              className="inline-flex items-center justify-center border-2 border-charcoal text-charcoal font-inter font-semibold px-8 py-4 rounded-full hover:bg-charcoal hover:text-warm-white transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Book a Discovery Call
            </Link>
          </div>
          
          <p className="font-inter text-sm text-charcoal/60 mt-8">
            Limited cohort sizes. Next intake: Spring 2025
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default LaunchpadHero;
